import { useState } from "react";
import { Download, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Subscribers() {
  const [key, setKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const load = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.get("/admin/subscribers", { params: { key } });
      setData(res.data);
    } catch {
      toast.error("Invalid access key.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="subscribers-page" className="pt-20 min-h-screen bg-[#F8F5F0]">
      <section className="max-w-3xl mx-auto px-6 py-24">
        <p className="text-xs uppercase tracking-[0.3em] text-[#C6A769] mb-6 text-center">Private</p>
        <h1 className="font-serif-display text-4xl sm:text-5xl text-[#4A3F35] mb-8 text-center">
          Newsletter Subscribers
        </h1>
        <div className="w-16 h-px bg-[#C6A769] mx-auto mb-12" />

        {!data ? (
          <form onSubmit={load} className="max-w-md mx-auto space-y-5" data-testid="admin-key-form">
            <div className="flex items-center gap-3 text-[#8A7D71] text-sm justify-center">
              <Lock className="w-4 h-4" strokeWidth={1.5} /> Enter your access key to view signups
            </div>
            <input
              type="password"
              required
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Access key"
              data-testid="admin-key-input"
              className="w-full bg-[#FAF7F2] border border-[#4A3F35]/15 rounded-sm px-5 py-4 text-sm text-[#4A3F35] outline-none focus:border-[#C6A769] transition-colors text-center"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="admin-key-submit"
              className="w-full bg-[#4A3F35] text-[#FAF7F2] py-4 rounded-sm text-sm uppercase tracking-[0.18em] hover:bg-[#C6A769] transition-colors duration-300 disabled:opacity-60 inline-flex items-center justify-center gap-2"
            >
              {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Checking…</> : "View Subscribers"}
            </button>
          </form>
        ) : (
          <div data-testid="subscribers-list">
            <div className="flex items-center justify-between mb-8">
              <p className="text-sm text-[#4A3F35]" data-testid="subscriber-count">
                <span className="font-serif-display text-3xl text-[#C6A769]">{data.count}</span>{" "}
                subscriber{data.count === 1 ? "" : "s"}
              </p>
              <a
                href={`${API_BASE}/admin/subscribers.csv?key=${encodeURIComponent(key)}`}
                data-testid="download-csv-button"
                className="inline-flex items-center gap-2 bg-[#C6A769] text-[#4A3F35] px-6 py-3 rounded-sm text-xs uppercase tracking-[0.18em] hover:bg-[#B08F50] transition-colors duration-300"
              >
                <Download className="w-4 h-4" strokeWidth={1.5} /> Download CSV
              </a>
            </div>
            <div className="bg-[#FAF7F2] border border-[#C6A769]/30 rounded-sm overflow-hidden">
              <table className="w-full text-sm text-left">
                <thead>
                  <tr className="text-[10px] uppercase tracking-[0.2em] text-[#C6A769] border-b border-[#C6A769]/20">
                    <th className="px-6 py-4 font-medium">Email</th>
                    <th className="px-6 py-4 font-medium">Source</th>
                    <th className="px-6 py-4 font-medium">Subscribed</th>
                  </tr>
                </thead>
                <tbody>
                  {data.subscribers.map((s, i) => (
                    <tr key={i} className="border-b border-[#4A3F35]/5 last:border-0 text-[#4A3F35]">
                      <td className="px-6 py-3">{s.email}</td>
                      <td className="px-6 py-3 text-[#8A7D71]">{s.source}</td>
                      <td className="px-6 py-3 text-[#8A7D71]">{(s.created_at || "").slice(0, 10)}</td>
                    </tr>
                  ))}
                  {data.subscribers.length === 0 && (
                    <tr><td colSpan="3" className="px-6 py-8 text-center text-[#8A7D71]">No subscribers yet.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
